export { default } from './FooterView';



// WEBPACK FOOTER //
// ./src/components/views/FooterView/index.js